var _style, _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLazypay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 600 450",
    style: {
      enableBackground: "new 0 0 600 450"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_00000008149873994990631360000008117606960440380349_);}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#010202;}\r\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#E83663;}\r\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#191832;}\r\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 49.4,
    y: 190.6,
    width: 500.5,
    height: 69.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000047748851579876006190000016478644967186158469_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000047748851579876006190000016478644967186158469_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M215.9,245.2v7.7c0,1.7-0.6,2.7-2.7,2.7h-38.2c-2.1,0-2.7-1-2.7-2.7v-55.7c0-2.1,1-2.7,2.7-2.7h9.1 c1.7,0,2.7,0.6,2.7,2.7v45.4h26.5C215.4,242.5,215.9,243.5,215.9,245.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M332.4,245.2v7.7c0,1.7-0.6,2.7-2.7,2.7h-40.1c-2.4,0-2.8-0.5-2.8-2.7v-7.3c0-2.1,1.2-3.5,1.2-3.5l24.8-34.7 h-22.5c-2.1,0-2.7-1-2.7-2.7V197c0-1.7,0.6-2.7,2.7-2.7h37c2.1,0,2.7,1,2.7,2.7v7.2c0,1.2-0.2,2.4-1.2,3.6l-24.6,34.6h25.5 C331.8,242.5,332.4,243.5,332.4,245.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M392.4,197l-18.9,35.6v20.3c0,2.1-1,2.7-2.7,2.7h-9.1c-1.8,0-2.7-0.6-2.7-2.7v-20.3L339.4,197 c-0.4-1-0.2-2.6,1.5-2.6h10.6c2.1,0,3,0.2,4.3,2.8l10.8,20l10.4-20c1.2-2.4,2.1-2.8,4.2-2.8h9.9 C392.8,194.3,392.9,195.9,392.4,197z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M434.9,216.1c0-4.8-3.1-8.8-10.2-8.8h-8.8v17.3h8.8C431.8,224.8,434.9,220.9,434.9,216.1z M448.8,215.9 c0,12.9-8.5,21.5-24.2,21.5h-8.8v15.4c0,2.1-1,2.7-2.7,2.7H404c-1.7,0-2.7-0.6-2.7-2.7v-55.7c0-1.7,0.6-2.7,2.7-2.7h20.7 C440.4,194.3,448.8,203.1,448.8,215.9z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M549.4,197l-18.9,35.6v20.3c0,2.1-1,2.7-2.7,2.7h-9.1c-1.8,0-2.7-0.6-2.7-2.7v-20.3L496.3,197 c-0.4-1-0.2-2.6,1.5-2.6h10.6c2.1,0,3,0.2,4.3,2.8l10.8,20l10.4-20c1.2-2.4,2.1-2.8,4.2-2.8h9.9 C549.7,194.3,549.9,195.9,549.4,197z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M223.2,252.8l19.6-55.6c1.1-2.4,1.8-2.8,3.8-2.8h8.8c2,0,2.7,0.3,3.8,2.8l19.7,55.6c0.4,1.2,0.1,2.7-1.7,2.7 h-10.2c-2.4,0-3-0.8-3.8-2.9l-12.3-38.5l-12.3,38.5c-0.8,2.3-1.3,2.9-3.9,2.9h-9.7C223.1,255.5,222.8,254,223.2,252.8z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M445.8,252.8l19.6-55.6c1.1-2.4,1.8-2.8,3.8-2.8h8.8c2,0,2.7,0.3,3.8,2.8l19.7,55.6c0.4,1.2,0.1,2.7-1.7,2.7 h-10.2c-2.4,0-3-0.8-3.8-2.9l-12.3-38.5L461,252.6c-0.8,2.3-1.3,2.9-3.9,2.9h-9.7C445.6,255.5,445.3,254,445.8,252.8z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M52.7,258.2c-2.5,0-3.2-1.2-3.2-3.3v-55.6c0-2.6,1.2-3.3,3.2-3.3h11c2,0,3.2,0.6,3.2,3.3v43"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M52.7,190.8l66.9,24.2c2.9,1.4,3.3,2.1,3.3,4.6v10.8c0,2.4-0.4,3.3-3.3,4.6l-66.9,24.3 c-1.5,0.6-3.2,0.1-3.2-2V245c0-2.9,0.9-3.7,3.6-4.6L99.2,225L53,209.6c-2.7-0.9-3.6-1.7-3.6-4.7V193 C49.5,190.7,51.3,190.3,52.7,190.8z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M76.4,190.8l66.9,24.2c2.9,1.4,3.3,2.1,3.3,4.6v10.8c0,2.4-0.4,3.3-3.3,4.6l-66.9,24.3 c-1.5,0.6-3.2,0.1-3.2-2V245c0-2.9,0.9-3.7,3.6-4.6l46.2-15.3l-46.2-15.4c-2.7-0.9-3.6-1.7-3.6-4.7V193 C73.2,190.7,74.9,190.3,76.4,190.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLazypay);
export default __webpack_public_path__ + "static/media/lazypay.4551a1391cc3ed3f83c69ae5f6ddf690.svg";
export { ForwardRef as ReactComponent };